import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import BackgroundImage from '../../assets/images/login-background.jpg';
import Logo from '../../assets/images/puntu-logo.svg';
import GoogleBadge from '../../assets/images/google-play-badge.svg';
import AppleBadge from '../../assets/images/apple-store-badge.svg';

const styles = theme => ({
  panel: {
    color: 'rgba(255, 255, 255, 0.75)',
    padding: theme.spacing(6),
    background: `url("${BackgroundImage}") no-repeat center`,
    backgroundSize: 'cover',
  },
  logo: {
    opacity: '0.75',
    width: '80px',
  },
  badge: {
    display: 'inline-block',
    width: '130px',
  },
});

const Panel = ({ classes, children }) => (
  <Hidden smDown>
    <Grid
      item
      xs={4}
      container
      direction="column"
      justify="space-between"
      className={classes.panel}
    >
      <Grid item>
        <img src={Logo} alt="Puntu" className={classes.logo} />
      </Grid>

      {React.Children.map(children, (element, index) => (
        <Grid item key={index}>
          {element}
        </Grid>
      ))}

      <Grid item container justify="center">
        <Typography variant="body2" color="inherit">
          Baixe nosso aplicativo nas lojas:
        </Typography>
        <Grid item>
          <a
            href="https://play.google.com/store/apps/details?id=com.cognusgroup.puntu.app"
            target="blank"
            className={classes.badge}
          >
            <img src={GoogleBadge} alt="Disponível no Google Play" />
          </a>
          <a
            href="https://itunes.apple.com/br/app/puntu/id1365551053?mt=8"
            target="blank"
            className={classes.badge}
          >
            <img
              src={AppleBadge}
              alt="Disponível na App Store"
              style={{ margin: '6%', width: '82%' }}
            />
          </a>
        </Grid>
      </Grid>
    </Grid>
  </Hidden>
);

Panel.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(Panel);
